<template>
  <div 
    class="fts-list-view-display fts-scrollbar fts-scrollbar-overlay" 
    :class="{ 
      'comfort-design': comfortMode, 
      'display-text-wrap': item.wrap 
    }">
    <template v-if="model">
      <!-- yes no -->
      <div class="yes-no-display" v-if="item.type === 1">
        <font-awesome-icon class="success-theme" :icon="['fas', 'check']" fixed-width v-if="model === 'Yes'" />
      </div>
      <!-- module -->
      <div class="dropdown-display" v-else-if="item.type === 7" :class="{ 'dropdown-display-link': locusURL }">
        <!-- legacy -->
        <a
          class="locus-link" 
          target="_blank" 
          :href="locusURL" 
          v-if="locusURL && legacy"
        >
          {{model}}
        </a>
        <!-- latest -->
        <a
          class="locus-link stopPropagation"
          target="_blank"
          :href="locusURL"
          @click.prevent="openQuickView"
          v-else-if="locusURL"
        >
          {{model}}
        </a>
        <!-- default -->
        <template v-else>{{model}}</template>
      </div>
      <!-- location -->
      <div class="location-display" v-else-if="item.type === 9">
        <template v-if="model && model.lat && model.lng">
          <a
            target="_blank"
            :href="'http://www.google.com/maps/place/' + model.lat + ',' + model.lng"
          >
            <font-awesome-icon :icon="['fas', 'map-marked-alt']" fixed-width />
          </a>
        </template>
        <div class="location-name">{{model.placeName}}</div>
      </div>
      <!-- image(s), file(s) -->
      <fts-file 
        :prefixURL="`${vectorId}-${item.id}`" 
        :data="model"
        :file-type="fileType"
        downloadable
        class="file-display"
        v-else-if="fileType" />
      <!-- table -->
      <fts-table-view 
        :vectorId="vectorId"  
        :columns="item.fields"
        :list="model"
        v-else-if="item.type === 14 && model && model.length > 0" />
      <!-- list -->
      <div class="list-display" v-else-if="item.type === 15">
        <div v-for="x in model" :key="x">{{x}}</div>
      </div>
      <!-- multiline text -->
      <div class="multi-text-display" v-else-if="item.type === 16">
        <span>{{model}}</span>
      </div>
      <!-- username, profile (module) -->
      <fts-profile 
        :userName="item.type === 19 ? model : userNameModel" 
        v-else-if="item.type === 19 || item.type === 20">
        <template #profileName="{userProfileUsername}">
          <!-- username -->
          <div v-if="item.type === 19">{{userProfileUsername}}</div>
          <!-- profile:legacy -->
          <a
            class="locus-link"
            target="_blank"
            :href="locusURL"
            v-else-if="locusURL && legacy"
          >
            {{model}}
          </a>
          <!-- profile:latest -->
          <a
            class="locus-link stopPropagation"
            :href="locusURL"
            target="_blank"
            @click.prevent="openQuickView"
            v-else-if="locusURL"
          >
            {{model}}
          </a>
          <!-- default -->
          <template v-else>{{model}}</template>
        </template>
      </fts-profile>
      <!-- content -->
      <div class="display-content" v-else-if="item.type === 22" v-html="model"></div>
      <!-- email -->
      <div class="email-display contact-link-display" v-else-if="item.type === 25">
        {{model}}
        <a :href="'mailto:' + model">
          <font-awesome-icon :icon="['far', 'envelope']" />
        </a>
      </div>
      <!-- phone number -->
      <div class="phone-number-display contact-link-display" v-else-if="item.type === 26">
        {{model}}
        <a target="_blank" :href="'https://api.whatsapp.com/send?phone=' + model">
          <font-awesome-icon :icon="['fab', 'whatsapp']" />
        </a>
      </div>
      <!-- select -->
      <div class="dropdown-display fts-display-form-tag" :style="{ 'background-color': getColor }" v-else-if="item.type === 27 && !item.reference">
        {{model}}
      </div>
      <!-- signature -->
      <fts-file 
        class="signature-display"
        :prefixURL="`${vectorId}-${item.id}`" 
        :data="model"
        file-type="image"
        file-content-class="signature-display-content"
        image-contain
        downloadable
        v-else-if="item.type === 29"/>
      <!-- link -->
      <div v-else-if="item.type === 33">
        <!-- link:query -->
        <div
          class="fts-link-primary"
          @click="toggleQueryUrl" 
          v-if="isQueryUrl"
        >
          {{model.name}}
        </div>
        <!-- link:UNC -->
        <a
          class="fts-link-primary"
          target="_blank"
          :href="uNCFilePath"
          v-else-if="uNCFilePath"
        >
          {{ model.name }}
        </a>
        <!-- link:default -->
        <a
          class="fts-link-primary"
          target="_blank"
          :href="linkURL"
          v-else-if="linkURL"
        >
          {{model.name}}
        </a>
        <!-- link:name -->
        <template v-else>{{model.name}}</template>
      </div>
      <!-- default -->
      <template v-else>{{model}}</template>
    </template>
    <!-- blank -->
    <div v-else>&nbsp;</div>
  </div>
</template>

<script>
import numeral from "numeral";

import { classificationStore } from "../store/classificationStore";
import commons from "../commons/commons";
import { uNCValidator } from "../commons/validator";

import FTSTableView from "./views/FTSTableView";
import FTSFile from "./file/FTSFile";
import FTSProfile from "./FTSProfile";

export default {
  store: classificationStore,
  props: {   
    formData: Object,
    item: Object,
    vectorId: [ Number, String ],
    mode: {
      type: String,
      default: "compact"
    },
    comfortMode: Boolean,
    legacy: Boolean,
  },
  components: {
    "fts-table-view": FTSTableView,
    "fts-file": FTSFile,
    "fts-profile": FTSProfile,
  },
  methods: {
    openQuickView() {
      window.eventBus.$emit("quickViewData", {
        items: [{ id: this.formData[this.item.fieldName + 'Id'] }],
      });
    },
    toggleQueryUrl() {
      try {
        const urlParams = new URLSearchParams(this.model.url);
        const params = Object.fromEntries(urlParams);
        if (params.d && params.id && params.v) {
          window.eventBus.$emit("showPDFDocument", {
            document: {id: params.d, typeId: 'pdf'},
            items: [{id: params.id}],
            moduleId: params.v
          });
        }
      } catch(err) {
        console.warn("ListViewDisplay:ToggleQueryUrl", err);
      }
    },
  },
  computed: {
    model() {
      /* for old data type */
      if (this.legacy) this.item.type = this.item.dataType
      
      const result = commons.model(this.formData, this.item.fieldName);
      if (result) {
        /* date */
        if (this.item.type === 5) {
          if (this.item.predefinedFormatId)
            return luxon.fromISO(result).toFormat(commons.dateFormatTranslate(this.item.predefinedFormatId));
          else 
            return luxon.fromISO(result).toFormat(commons.dateFormatTranslate("DD"));
        }
        /* date time */
        else if (this.item.type === 6) {
          if (this.item.predefinedFormatId)
            return luxon.fromISO(result).toFormat(commons.dateFormatTranslate(this.item.predefinedFormatId));
          else 
            return luxon.fromISO(result).toFormat(commons.dateFormatTranslate("DD t"));
        }
        /* table */
        else if (this.item.type === 14 && !result.length) {
          return null;
        } 
        /* list */
        else if (this.item.type === 15)  {    
          if (result.length) {
            function remap(fieldName) {
              return result.map(x => x[fieldName]).filter(y => y)
            }
            // displayField
            if (this.item.displayField) {
              const field = this.item.fields.find(x => x.displayName === this.item.displayField)
              if (field.fieldName)
                return remap(field.fieldName)
            }
            // default
            const fields = this.item.fields.filter(
              x => [0, 1, 2, 3, 4, 5, 6, 7, 9, 16, 19, 20, 25, 26, 27, 33].some(y => y === x.type)
            )
            if (fields.length) 
              return remap(fields[0].fieldName)
          }
          return []
        } 
        /* yes no */
        else if (this.item.type === 1) {
          return result ? "Yes" : "No";
        }
        /* number */
        else if (this.item.type === 3) {
          if (this.item.customFormat) {
            return numeral(result).format(this.item.customFormat);
          } else if (this.item.displayFormat) {
            return numeral(result).format(this.item.displayFormat);
          } else {
            const decimalPlaces = commons.isInteger(this.item.decimalPlaces) ? this.item.decimalPlaces : 2;
            return result.toLocaleString(undefined, {
              minimumFractionDigits: decimalPlaces,
              maximumFractionDigits: decimalPlaces,
            });
          }
        }
        /* money */
        else if (this.item.type === 4) {
          return numeral(result).format("0,0.00");
        }
        /* location */
        else if (this.item.type == 9) {
          /* for old data */
          return {
            lat: result.lat ? result.lat : result.latitude,
            lng: result.lng ? result.lng : result.longitude,
            placeName: result.placeName,
          };
        }
        /* link */
        else if (this.item.type === 33) {
          if (result.constructor === String)
            return {
              url: result,
              name: result,
            };
          else if (result.constructor == Object) 
            return result.name === null || result.name === undefined ?
              {...result, name: '(undefined)'} : result;

          return { name: 'invalid URL' }
        }
        /* default */
        return result;
      } else if (this.item.type === 1 && result === false) {
        return "No";
      }
      else if ((this.item.type === 2 || this.item.type === 3) && result === 0) {
        return "0";
      } 
      else if (this.item.type === 4 && result === 0) {
        return "0.00";
      } else {
        return null;
      }
    },
    userNameModel() {
      return commons.model(this.formData, `${this.item.fieldName}Username`);
    },
    fileType() {
      if (this.item.type === 10 || this. item.type === 11)
        return 'image'
      else if (this.item.type === 12 || this.item.type === 13)
        return 'file'
    },
    getColor() {
      return commons.selectOptionBackground({
        optionList: this.item.optionList,
        text: this.model,
      });
    },
    locusURL() {
      const locusId = commons.model(this.formData, this.item.fieldName, true);
      return locusId ?
        this.legacy ? 
          "/#/locus/view/" + locusId + "///" :
          `/#/dashboard?id=${commons.encodeids(locusId)}`
        : null;
    },
    /* link */
    isQueryUrl() {
      return Boolean(
        this.model && 
        this.model.url && 
        this.model.url.startsWith("?")
      );
    },
    linkURL() {
      if (this.model && this.model.url)
        return this.model.url.toLowerCase().startsWith("http") ? this.model.url : `//${this.model.url}`
    },
    uNCFilePath() {
      if (this.model && this.model.url && uNCValidator(this.model.url)) {
        if (/^([a-zA-Z]\:\\|\\\\)/g.test(this.model.url))
          return `ist://${this.model.url}`;
        else
          return `file:///${this.model.url}`;
      }
    },
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-list-view-display {
  font-size: 0.825rem;
  word-break: break-word;
  &.display-text-wrap {
    white-space: normal;
  }

  &.comfort-design {
    font-size: 0.875rem;
    .multi-text-display {
      span {
        white-space: pre-wrap;
      }
    }
  }

  .fts-display-form-tag {
    display: inline-flex;
    padding: 0 .375rem;
    border-radius: .25rem;
    width: auto;
    color: #000;
  }
  .yes-no-display {
    .success-theme {
      color: var(--fts-success);
    }
    .danger-theme {
      color: var(--fts-danger);
    }
  }
  .list-display {
    @include flex-gap($gap: .375rem, $wrap: nowrap);
    min-width: 0;
    > div {
      @include text-overflow-ellipsis;
      padding: .15rem .175rem;
      background: var(--fts-gray-4);
      border-radius: .25rem;
    }
  }

  .multi-text-display {
    min-width: 150px;
    span {
      white-space: pre-wrap;
    }
  }
  .location-display {
    display: flex;
    align-items: baseline;
    white-space: normal;
    a {
      color: $primaryColor;
    }
    .location-name {
      margin-left: 0.375rem;
    }
  }
  .file-display {
    .file-container {
      flex-wrap: nowrap;
    }
  }
  .dropdown-display {
    &.dropdown-display-link {
      display: inline-flex;
      &:hover {
        .external-link-icon {
          visibility: visible;
        }
      }
      .external-link-icon {
        margin-left: .375rem;
        color: var(--fts-gray-5);
        visibility: hidden;
        > svg {
          color: inherit;
        }
      }
    }
  }
  .dropdown-user-display {

  }
  .locus-link {
    color: $primaryColor;
    text-decoration: none;
    cursor: pointer;
  }
  .contact-link-display {
    display: flex;
    &:hover {
      > a {
        visibility: visible;
      }
    }
    > a {
      visibility: hidden;
      margin-top: -3px;
      margin-left: 0.375rem;
      font-size: 1.25rem;
      svg {
        color: var(--fts-gray-5);
      }
    }
  }
  .phone-number-display {

  }
  .email-display {

  }
  .signature-display {
    .signature-display-content {
      border: 1px solid var(--fts-gray-3);
    }
  }
}
</style>